<app-header
*ngIf="!router.url.split('?')[0].includes('/signin') && router.url != '/signup' && router.url != '/forgot-password' && router.url != '/reset-password' && !router.url.split('?')[0].includes('/verify-email')">
</app-header>
<router-outlet></router-outlet>